<template>
    <div class="user-avatar-dropdown">
        <div class="item">
            <common-icon type="_user" :size="24"></common-icon>
            <span class="name">{{$store.getters.userName}}</span>
        </div>
        <div class="item" @click="handleClick('logout')">
            <common-icon type="_poweroff" :size="24"></common-icon>
            <span class="exit">退出</span>
        </div>
    </div>
</template>

<script>
    import CommonIcon from '_c/common-icon'
    import './user.less'

    export default {
        name: 'User',
        props: {
            userAvatar: {
                type: String,
                default: ''
            },
            messageUnreadCount: {
                type: Number,
                default: 0
            }
        },
        components: {
            CommonIcon
        },
        methods: {
            logout() {
                this.$store.dispatch('Logout').then(() => {
                    this.$router.push('/login');
                });
            },
            handleClick(name) {
                let _th = this
                switch (name) {
                    case 'logout':
                        this.logout()
                        break;
                    case 'message':
                        this.message();
                        break;
                }
            }
        }
    }
</script>
